/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Law_Stat3_Line2Inputs */

const es_landing_law_stat3_line2 = /** @type {(inputs: Landing_Law_Stat3_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de alquiler permitido`)
};

const gl_landing_law_stat3_line2 = /** @type {(inputs: Landing_Law_Stat3_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de alugueiro permitido`)
};

const en_landing_law_stat3_line2 = /** @type {(inputs: Landing_Law_Stat3_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of rental allowed`)
};

/**
* | output |
* | --- |
* | "of rental allowed" |
*
* @param {Landing_Law_Stat3_Line2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_law_stat3_line2 = /** @type {((inputs?: Landing_Law_Stat3_Line2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Law_Stat3_Line2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_law_stat3_line2(inputs)
	if (locale === "en") return en_landing_law_stat3_line2(inputs)
	return es_landing_law_stat3_line2(inputs)
});